import { StyleSheet, Dimensions } from 'react-native'
import theme from '../../../theme'

const { width, height } = Dimensions.get('window')

const styles = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: 'white',
    },
    categoryContainer: {
        flex: 1,
        borderRadius: 5,
        borderWidth: 0.2,
        borderColor: 'black',
        marginHorizontal: 10,
        marginBottom: 10,
        overflow: 'hidden',
        height: 160,
    },
    brandContainer: {
        flex: 1,
        marginHorizontal: 10,
        marginBottom: 20,
        overflow: 'hidden',
    },
    brandImage: {
        aspectRatio: 1,
        borderRadius: 25,
        borderWidth: 0.5,
        borderColor: theme.colors.lightGray,
    },
    // image: {
    //     height: width / 2 - 20,
    //     aspectRatio: 1,
    //     borderRadius: 25,
    //     overflow: 'hidden',
    // },
    imageStyle: {
        borderRadius: 25,
    },
    overlay: {
        ...StyleSheet.absoluteFillObject,
        backgroundColor: 'red',
    },
    categoryContainerImageBackground: {
        flex: 1,
        padding: 10,
        backgroundImage: "url('https://example.com/background-image.jpg')",
        backgroundSize: 'cover',
        backgroundPosition: 'center',
    },
    portfolioHeader: {
        paddingHorizontal: 10,
    },
    titleSection: {
        fontSize: 20,
        fontWeight: 'bold',
        color: theme.colors.textPrimary,
        marginBottom: 5,
    },
    descriptionSection: {
        fontSize: 16,
        fontWeight: 'normal',
        color: theme.colors.textSecondary,
        marginBottom: 10,
    },
    titleCategory: {
        fontSize: 16,
        fontWeight: 'bold',
        marginBottom: 5,
    },
    descriptionCategory: {
        fontSize: 14,
        fontWeight: 'normal',
    },
    containerNoProducts: {
        flex: 1,
        backgroundColor: 'white',
        flexDirection: 'column',
        justifyContent: 'center',
        alignContent: 'center',
        alignItems: 'center',
    },
    image: {
        width: 120,
        height: 120,
    },
    title: {
        fontSize: 18,
        fontWeight: 'bold',
        color: theme.colors.textPrimary,
        textAlign: 'center',
        marginBottom: 5,
        marginTop: 10,
        paddingHorizontal: 40,
    },
    description: {
        fontSize: 16,
        fontWeight: 'normal',
        color: theme.colors.textSecondary,
        textAlign: 'center',
        paddingHorizontal: 40,
    },
    spacer1: {
        height: 12,
    },
})

export default styles
